import React, { useEffect, useState } from "react";
import { ProfileService } from "../../../../services/ProfileService";
import { showSalary } from "../../../../utilities/showsalary";
import { FaAngleUp } from "react-icons/fa";
import Firebaselogin from "../../../user/login";
import { useHistory } from "react-router-dom";
import bgimage from "../../../../assets/img/images/teamanics_logo_4.png";
import { Button } from "reactstrap";
import SvgBellIcon from "../templateinfo.js/bellicon";
import TagLine from "../templateinfo.js/tagline";
import Footer from "../templateinfo.js/footer";
import FeaturedEmp from "../templateinfo.js/featuredempimages";
import LpImages from "../templateinfo.js/lpimage";
import { Stringutility } from "../../../../utilities/stringutility";
import { StorageService } from "../../../../services/StorageService";
import { StorageValues } from "../../../../constants/storageValues";
import { GenericCodes } from "../../../../constants/genericCodeValues";
import { Constants } from "../../../../constants/constantValues";

const JobTemplate001 = (props) => {
  var jobId = Stringutility.getValue(props.jobId).trim();
  var flavor = Stringutility.getValue(props.flavor).trim();

  const history = useHistory();
  const [title, setTitle] = useState("");
  const [address, setaddress] = useState({});
  const [salarymax, setsalarymax] = useState(0);
  const [salarytype, setsalarytype] = useState("");
  const [duration, setduration] = useState("");
  const [durationType, setdurationType] = useState("");
  const [jobtype, setjobtype] = useState("");
  const [workModel, setWorkModel] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [jobDescription, setjobDescription] = useState("");
  const [jobRequirements, setjobRequirements] = useState("");
  const [jobResponsibilities, setjobResponsibilities] = useState([]);
  const [benefits, setBenefits] = useState({});
  const [logo, setLogo] = useState("");
  const [backGroundImage, setBackGroundImage] = useState("");
  const [showPay, setShowPay] = useState("");
  const [toggleState, setToggleState] = useState(1);
  const [showErrorData, setShowErrorData] = useState(false);
  const [isValidJob, setIsValidJob] = useState(true);
  const [adlBenefits, setAdlBenefits] = useState([]);
  const [adlAdditionalPayInfo, setAdditionalPayInfo] = useState("");
  const [displayAccountInfo, setDisplayAccountInfo] = useState(true);

  const [imagesList, setImagesList] = useState([
    {
      key: "admin_assistant",
      value: "admin_assistant_01.png",
    },

    {
      key: "bilingual_FDR",
      value: "Bilingual_FDR_01.png",
    },

    {
      key: "biller",
      value: "biller_med01.png",
    },
    {
      key: "business",
      value: "img_business.png",
    },

    {
      key: "cashier",
      value: "cashier_01.png",
    },

    {
      key: "counselor",
      value: "counselor_01.png",
    },

    {
      key: "da",
      value: "DA_02.png",
    },

    {
      key: "data-entry",
      value: "data-entry_01.png",
    },

    {
      key: "driver",
      value: "img_driver_02.png",
    },

    {
      key: "factory-worker",
      value: "factory-worker-01.png",
    },

    {
      key: "fdr",
      value: "FDR_02.png",
    },

    {
      key: "FDR_hispanic",
      value: "FDR_hispanic_01.png",
    },

    {
      key: "floral_designer",
      value: "floral_designer_01.png",
    },

    {
      key: "food_packer",
      value: "food_packer.png",
    },

    {
      key: "food-clerk",
      value: "food-clerk-01.png",
    },

    {
      key: "food-prep",
      value: "food-prep-01.png",
    },

    {
      key: "hr-manager",
      value: "hr-manager-01.png",
    },

    {
      key: "img_analyst",
      value: "img_analyst_01.png",
    },

    {
      key: "billing",
      value: "img_billing.png",
    },

    {
      key: "cable_technician",
      value: "img_cable_technician.png",
    },

    {
      key: "cheesemonger",
      value: "img_cheesemonger.png",
    },

    {
      key: "clerk",
      value: "img_clerk.png",
    },

    {
      key: "clerk_butcher",
      value: "img_clerk_butcher_01.png",
    },

    {
      key: "courtesy_clerk",
      value: "img_courtesy_clerk.png",
    },

    {
      key: "customer_specialist",
      value: "img_customer_specialist.png",
    },

    {
      key: "developer",
      value: "img_developer.png",
    },

    {
      key: "floating",
      value: "img_floating.png",
    },

    {
      key: "Food_worker",
      value: "img_Food_worker.png",
    },

    {
      key: "helpdesk",
      value: "img_helpdesk.png",
    },

    {
      key: "mrc",
      value: "img_mrc_01.png",
    },

    {
      key: "wine_steward",
      value: "img_wine_steward.png",
    },

    {
      key: "it-manager",
      value: "it-manager-01.png",
    },

    {
      key: "lab_tech",
      value: "LAB_TECH_01.png",
    },

    {
      key: "lady_scrubs_mob",
      value: "lady_scrubs_mob.png",
    },

    {
      key: "logistic",
      value: "logistic_01.png",
    },

    {
      key: "manager",
      value: "MANAGER_01.png",
    },

    {
      key: "med_assistant",
      value: "Med_Assistant_01.png",
    },

    {
      key: "optical_receptionist",
      value: "optical_receptionist_01.png",
    },

    {
      key: "pcc",
      value: "PCC_01.png",
    },

    {
      key: "pharma",
      value: "PHARMA_01.png",
    },

    {
      key: "physical",
      value: "Physical_T_01.png",
    },

    {
      key: "sales",
      value: "sales_01.png",
    },
    {
      key: "safety",
      value: "img_safety.png",
    },

    {
      key: "sales_intern",
      value: "sales_intern_01.png",
    },

    {
      key: "vet",
      value: "VET_01.png",
    },

    {
      key: "wine-specialist",
      value: "wine-specialist-02.png",
    },

    {
      key: "hardware",
      value: "hardware.png",
    },
  ]);

  const [image, setImage] = useState("");

  const [salMin, setSalMin] = useState(0);

  const getJobBenefits = (moBenefits) => {
    let benefits = [];
    if (moBenefits.health === true) {
      benefits.push("Health Insurance");
    }
    if (moBenefits.dental === true) {
      benefits.push("Dental Insurance");
    }
    if (moBenefits.vision === true) {
      benefits.push("Vision Insurance");
    }
    if (moBenefits.cobra === true) {
      benefits.push("Cobra");
    }
    if (moBenefits.Disability === true) {
      benefits.push("Disability");
    }
    if (moBenefits.medicalLeave === true) {
      benefits.push("Medical Leave");
    }
    if (moBenefits.minimumWage === true) {
      benefits.push("Minimum Wage");
    }
    if (moBenefits.overtime === true) {
      benefits.push("Overtime");
    }
    if (moBenefits.unEmploymentBenefit === true) {
      benefits.push("Unemployment Benefits");
    }
    if (moBenefits.WorkerCompensation === true) {
      benefits.push("Worker Compensation");
    }
    if (moBenefits.bonusPay === true) {
      benefits.push("Bonus Pay");
    }
    if (moBenefits.compensation401k === true) {
      benefits.push("Competitive 401k with company match");
    }
    if (moBenefits.stockOption === true) {
      benefits.push("Stock Options");
    }

    if (moBenefits.lifeInsurance === true) {
      benefits.push("Life Insurance");
    }
    if (moBenefits.paidHoliday === true) {
      benefits.push("Paid Holidays");
    }
    if (moBenefits.paidSickTime === true) {
      benefits.push("Paid Sick Time");
    }
    if (moBenefits.flexibleHour === true) {
      benefits.push("Flexible Hours");
    }
    if (moBenefits.parentalLeave === true) {
      benefits.push("Parental Leave");
    }
    if (moBenefits.tuition === true) {
      benefits.push("Tuition Reimbursement");
    }
    if (moBenefits.profDeveAssistance === true) {
      benefits.push("Professional Development Assistance");
    }
    if (moBenefits.empDiscount === true) {
      benefits.push("Employee Discounts");
    }
    return benefits.join(", ");
  };

  let count = 0;
  useEffect(() => {
    if (!Stringutility.isNullOrEmpty(jobId)) {
      getjobdetails();
    }

    if (!Stringutility.isNullOrEmpty(flavor)) {
      for (let i = 0; i < imagesList.length; i++) {
        if (flavor == imagesList[i].key) {
          setImage(imagesList[i].value);
        }
      }
    }
  }, [count]);

  useEffect(() => {   
  }, []);

  const handleapplyjob = () => {
    StorageService.saveInSessionStorage(
      StorageValues.APPLY_JOB,
      "clickapplybutton"
    );
    window.location.href = "/";
  };

  const navigatehome = () => {
    window.localStorage.setItem("page", "");
    window.location.href = "/";
    StorageService.removeItemInSessionStorage(StorageValues.JOB_ID);
  };

  const getjobdetails = () => {
    const regex = /(<([^>]+)>)/gi;
    ProfileService.getJobdetails(jobId).then((response) => {
      try {
        if (response.data != null) {
          var appliedjobdetails = response.data;

          if (appliedjobdetails.failure_code == GenericCodes.invalidJob) {
            setShowErrorData(true);
            Stringutility.showErrorMessage(Constants.invalidJobRequisition);
            setIsValidJob(false);
          } else {
            setShowErrorData(false);
          }

          if (response.status == 200) {
            if (appliedjobdetails.title != null) {
              setTitle(appliedjobdetails.title);
            }

            if (appliedjobdetails.salaryMin !== 0) {
              setSalMin(appliedjobdetails.salaryMin);
            } else {
              setSalMin(0);
            }

            setsalarymax(appliedjobdetails.salaryMax);

            if (!Stringutility.isNullOrEmpty(appliedjobdetails.salaryType)) {
              setsalarytype(appliedjobdetails.salaryType.value);
            }

            if (appliedjobdetails.showPay == true) {
              setShowPay(appliedjobdetails.showPay);
            }

            if (appliedjobdetails.displayAccountInfo != null) {
              setDisplayAccountInfo(appliedjobdetails.displayAccountInfo);
            }

            if (appliedjobdetails.jobType != null) {
              setjobtype(appliedjobdetails.jobType.value);
            }
            if (appliedjobdetails.workModel != null) {
              setWorkModel(appliedjobdetails.workModel.value);
            }
            if (appliedjobdetails.additionalPayInfo != null) {
              setAdditionalPayInfo(appliedjobdetails.additionalPayInfo);
            }

            if (appliedjobdetails.duration != null) {
              setduration(appliedjobdetails.duration);
              setdurationType(appliedjobdetails.durationType.value);
            }

            if (appliedjobdetails.jobDescription !== null) {
              setjobDescription(appliedjobdetails.jobDescription);
            }
            if (appliedjobdetails.jobRequirements !== null) {
              setjobRequirements(appliedjobdetails.jobRequirements);
            }
            if (appliedjobdetails.jobResponsibilities !== null) {
              setjobResponsibilities(appliedjobdetails.jobResponsibilities);
            }

            if (appliedjobdetails.jobBenefits !== null) {
              setBenefits(appliedjobdetails.jobBenefits);
              setAdlBenefits(appliedjobdetails.jobBenefits.perks);
            }

            if (appliedjobdetails.account != null) {
             setCompanyName(appliedjobdetails.account.name); 

             setLogo(appliedjobdetails.account.logo);
             setBackGroundImage(appliedjobdetails.account.bgImage);
            }

            if (appliedjobdetails.location != "") {
              if (appliedjobdetails.location.address != null) {
                setaddress(appliedjobdetails.location.address);
              }
            }
          }
        }
      } catch (err) {
        console.error("getJobdetails" + JSON.stringify(err));
      }
    });
  };
  const displayAdditionalBenefits = (adlBenefitsList) => {
    return (
      <>
        {(() => {
          if (!Stringutility.isNullOrEmpty(adlBenefitsList)) {
            if (adlBenefitsList.length > 0) {
              return (
                <div>
                  <strong className="text-[15px] font-semibold font-assistant">
                    Additional Benefits
                  </strong>
                  <span className="text-sm inline-block min-sm:w-[81%] font-assistant">
                    {adlBenefitsList.join(", ")}
                  </span>
                </div>
              );
            }
          }
        })()}
      </>
    );
  };

  function openCity(evt, cityName) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    evt.currentTarget.className += " active";
  }

  const toggleTab = (index) => {
    // alert(index)
    setToggleState(index);
  };

  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }
  const getAddress = (addressObj) => {
    let add = "";

    if (!Stringutility.isNullOrEmpty(addressObj.city)) {
      add += addressObj.city + ", ";
    }
    if (!Stringutility.isNullOrEmpty(addressObj.state)) {
      add += addressObj.state + ", ";
    }
    if (!Stringutility.isNullOrEmpty(addressObj.zipcode)) {
      add += addressObj.zipcode;
    }
    let address = add.replace(/,(?=\s*$)/, "");
    return address;
  };

  function changeTab(event, index) {
    var tabButtons = document.getElementById("tab-buttons").children;
    var tabPanels = document.getElementById("tab-panels").children;
    for (var i = 0; i < tabButtons.length; i++) {
      tabButtons[i].classList.remove("text-primary-white");
      tabButtons[i].classList.remove("bg-primary-blue");
      tabButtons[i].classList.add("text-primary-blue");
      tabPanels[i].classList.add("hidden");
    }

    tabButtons[index].classList.remove("text-primary-blue");
    tabButtons[index].classList.add("text-primary-white");
    tabButtons[index].classList.add("bg-primary-blue");
    tabPanels[index].classList.remove("hidden");
  }

  const checkJobSalary = (salaryMin, salaryMax, salarytype) => {
    if (salaryMin == 0 && salaryMax == 0) {
      return <></>;
    } else if (salaryMin !== 0 && salaryMax == 0) {
      return (
        <div className="jobbrief_salary inline-block px-7 mb-3 ">
          <strong className="text-[32px] font-semibold max-sm:text-[24px]">
            {"$" + showSalary(salaryMin, salMin, salarymax)}
          </strong>
          <br />
          <span className="text-[18px] font-semibold font-assistant">
            {capitalizeFirstLetter(salarytype)}{" "}
            {adlAdditionalPayInfo && (
              <>
                {""} + {""}
                {adlAdditionalPayInfo}
              </>
            )}
          </span>
        </div>
      );
    } else if (salaryMin == 0 && salaryMax !== 0) {
      return (
        <div className="jobbrief_salary  inline-block px-7 mb-3 ">
          <strong className="text-[32px] font-semibold max-sm:text-[24px]">
            {"$" + showSalary(salaryMax, salMin, salarymax)}
          </strong>
          <br />
          <span className="text-[18px] font-semibold font-assistant">
            {capitalizeFirstLetter(salarytype)}{" "}
            {adlAdditionalPayInfo && (
              <>
                {""} + {""}
                {adlAdditionalPayInfo}
              </>
            )}
          </span>
        </div>
      );
    } else if (salaryMin == salaryMax) {
      return (
        <div className="jobbrief_salary  inline-block px-7 mb-3 ">
          <strong className="text-[32px] font-semibold max-sm:text-[24px]">
            {"$" + showSalary(salaryMin, salMin, salarymax)}
          </strong>
          <br />
          <span className="text-[18px] font-semibold font-assistant">
            {capitalizeFirstLetter(salarytype)}{" "}
            {adlAdditionalPayInfo && (
              <>
                {""} + {""}
                {adlAdditionalPayInfo}
              </>
            )}
          </span>
        </div>
      );
    } else {
      return (
        <div className="jobbrief_salary  inline-block px-7 mb-3 ">
          <strong className="text-[32px] font-semibold max-sm:text-[24px]">
            {"$" +
              showSalary(salaryMin, salMin, salarymax) +
              "-" +
              "$" +
              showSalary(salaryMax, salMin, salarymax)}
          </strong>
          <br />

          <span className="text-[18px] font-semibold font-assistant">
            {capitalizeFirstLetter(salarytype)}{" "}
            {adlAdditionalPayInfo && (
              <>
                {""} + {""}
                {adlAdditionalPayInfo}
              </>
            )}
          </span>
        </div>
      );
    }
  };

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const showJobType = (jobType) => {
    if (jobType === "Any") {
      return "Full Time/Part Time ";
    }
    return jobType;
  };
  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const displayJobAddress = () => {
    return (
      <>
        {displayAccountInfo == true ? (
          <>
            {!Stringutility.isNullOrEmpty(getAddress(address)) ? (
              <>{companyName + ", " + getAddress(address)}</>
            ) : (
              <>{companyName}</>
            )}
          </>
        ) : (
          <>
            {!Stringutility.isNullOrEmpty(getAddress(address)) && (
              <>{getAddress(address)}</>
            )}
          </>
        )}
      </>
    );
  };

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="true"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Assistant:wght@200;300;400;500;600;700;800&display=swap"
        rel="stylesheet"
      />

      <div className="bg-primary-white font-assistant tracking-wide text-primary-dark overflow-x-hidden  scrollbar-thin scrollbar-thumb-Blue-700 scrollbar-track-Gray-200 overflow-y-scroll scrollbar-thumb-rounded bg-no-repeat bg-fixed bg-cover">
        <header
          className="bg-gradient-to-br from-primary-white to-primary-white  
        top-0 w-full max-sm:h-[30px] max-sm:-z-10 min-sm:z-0 min-sm:h-16 shadow-primary-gray"
        ></header>
        <div className="t-top-to-btm">
          {" "}
          {showTopBtn && (
            <FaAngleUp
              className="t-icon-position t-icon-style"
              onClick={goToTop}
            />
          )}{" "}
        </div>

        <div className=" max-xl:w-screen max-sm:overflow-hidden max-sm:px-4 max-xl:px-7 min-xl:w-[80%] min-xl:mx-[10%]">
          <div className=" min-sm:ml-9 w-48 min-sm:top-[16px] min-sm:absolute z-30 max-sm:mx-auto">
            <a href="#">
              {" "}
              <img src={bgimage} alt="Teamanics" />
            </a>
          </div>

          <main style={{ zIndex: "23" }}>
            <LpImages />
            <div className="bodyContent min-sm:w-[97vw] min-sm:px-12 min-xl:w-[80vw] grid min-sm:gap-x-16 gap-y-4 min-sm:grid-cols-3 min-sm:top-12 -z-10 max-sm:grid-cols-1 mb-7">
              <div
                id="job_717"
                className="signUp min-sm:col-span-1 min-sm:row-span-3 max-sm:col-span-full "
              >
                <div className="flex flex-col gap-4 blueBGBox bg-gradient-to-br from-primary-blue to-primary-blue3 rounded-3xl mt-[200px] min-sm:min-h-[300px] ">
                  <div>
                    {!Stringutility.isNullOrEmpty(image) ? (
                      <img
                        className="w-[100%] scale-105 -mt-[180px]"
                        src={window.location.origin + "/assets/img/lp/" + image}
                        alt="Job Image"
                      />
                    ) : (
                      <img
                        className="w-[100%] scale-105 -mt-[180px]"
                        src={
                          window.location.origin +
                          "/assets/img/lp/it-manager-01.png"
                        }
                        alt="Job Image"
                      />
                    )}
                  </div>

                  <div className="signUpForm pt-[0px] px-10 text-primary-white pb-7">
                    {showErrorData === false ? (
                      <>
                        {window.localStorage.getItem("user") == null ? (
                          <>
                            <h2 className="text-center text-2xl font-bold">
                              Apply Now
                            </h2>
                            <div className="signUp_form">
                              <Firebaselogin />
                            </div>
                          </>
                        ) : (
                          <div className="text-center text-2xl font-bold">
                            <Button
                              outline
                              type="submit"
                              color="light"
                              onClick={handleapplyjob}
                            >
                              <strong>
                                <h3>Apply Now</h3>{" "}
                              </strong>
                            </Button>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {" "}
                        <div className="text-center text-2xl font-bold">
                          <Button
                            outline
                            color="light"
                            type="submit"
                            onClick={navigatehome}
                          >
                            <h3> Home</h3>
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {showErrorData === false ? (
                <div className=" min-sm:col-span-2 mt-[60px] max-sm:px-4">
                  <div className="jobtitle">
                    <span className="text-[32px] font-semibold font-assistant ">
                      {title}
                    </span>
                    <p className="font-bold font-assistant">
                      {displayJobAddress()}
                    </p>
                    <SvgBellIcon />
                  </div>

                  <div className="jobbrief_all border rounded-xl pt-3 pb-[10px] mb-3 mt-4 bg-primary-white/50 min-sm:-ml-1 font-assistant">
                    {showPay ? (
                      <>
                        <div className="row">
                          <div className="col-7">
                            {checkJobSalary(salMin, salarymax, salarytype)}
                          </div>
                          <div className="col-5">
                            <div className="jobbrief_salary inline-block px-7 mt-1">
                              <strong className="text-[24px] font-semibold max-sm:text-[24px]">
                                {showJobType(jobtype)}
                              </strong>
                              <br />
                              <span className="text-[18px] font-semibold font-assistant">
                                {workModel}
                              </span>
                              <br />
                              <span className="text-sm font-light leading-3">
                                &nbsp;
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-5">
                          <div className="jobbrief_salary inline-block px-7 mt-1">
                            <strong className="text-[24px] font-semibold max-sm:text-[24px]">
                              {showJobType(jobtype)}
                            </strong>
                            <br />
                            <span className="text-[18px] font-semibold font-assistant">
                              {workModel}
                            </span>
                            <br />
                            <span className="text-sm font-light leading-3">
                              &nbsp;
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                    {!isEmpty(benefits) && (
                      <div className="jobbrief_info inline-block px-7 mb-3 min-sm:w-[100%]">
                        <strong className="text-[24px] font-semibold font-assistant">
                          Benefits
                        </strong>
                        <br />
                        <span className="text-sm inline-block min-sm:w-[81%] font-assistant">
                          {getJobBenefits(benefits)}{" "}
                        </span>
                        <br />
                        {displayAdditionalBenefits(adlBenefits)}
                        <br />
                      </div>
                    )}
                  </div>
                  <TagLine />
                </div>
              ) : (
                <div className=" min-sm:col-span-2 mt-[60px] max-sm:px-4">
                  <div className="jobtitle">
                    <span className="text-[32px] font-semibold font-assistant ">
                      {title}
                    </span>
                    <p className="font-bold font-assistant">                     
                      {displayJobAddress()}
                    </p>
                  </div>

                  <div className="jobbrief_all border rounded-xl pt-5 pb-[10px] mb-3 mt-7 bg-primary-white/50 min-sm:-ml-1">
                    <>
                      <div className="jobbrief_salary min-sm:w-[40%] inline-block px-7 mb-5 "></div>
                      <div className="jobbrief_type text-[32px] font-semibold min-sm:w-[60%] inline-block px-7 mb-5">
                        <strong className="text-[24px] font-semibold font-assistant">
                          {" "}
                          Invalid Job Requisition
                        </strong>
                        <br />
                      </div>
                    </>
                  </div>
                </div>
              )}

              {showErrorData === false ? (
                <div className="JobDescription  min-sm:col-span-2">
                  <div className="tabs rounded-xl overflow-hidden ">
                    <div className="drop-shadow-lg">
                      <div
                        id="tab-buttons"
                        className="flex max-md:flex-col max-md:gap-2 max-md:w-[97%]"
                      >
                        <span
                          // href="javascript:void(0)"
                          onClick={(e) => changeTab(e, 0)}
                          className="inline-block min-sm:px-8 py-3 temanics-link-pointer max-sm:px-3 max-sm:py-1 text-primary-white font-semibold temanics-border-width bg-primary-blue border-primary-blue mr-1 rounded-tl-xl"
                        >
                          Job Description
                        </span>
                        <span
                          // href="javascript:void(0)"
                          onClick={(e) => changeTab(e, 1)}
                          className="inline-block min-sm:px-8 py-3 temanics-link-pointer max-sm:px-3 max-sm:py-1 text-primary-blue font-semibold temanics-border-width border-primary-blue mr-1"
                        >
                          Responsibilities
                        </span>

                        <span
                          // href="javascript:void(0)"
                          onClick={(e) => changeTab(e, 2)}
                          className="inline-block min-sm:px-8 py-3 temanics-link-pointer max-sm:px-3 max-sm:py-1 text-primary-blue font-semibold temanics-border-width border-primary-blue mr-1"
                        >
                          Requirements
                        </span>
                      </div>

                      <div
                        id="tab-panels"
                        className=" bg-white px-12 pt-4 pb-7  border-primary-blue  temanics-border-width rounded-b-xl rounded-tr-xl -mt-[1px] shadow-inner "
                      >
                        <div className="jobBox rounded-2xl">
                          <div className="text-base pt-3">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: jobDescription,
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="jobBox hidden rounded-2xl">
                          <div className="text-base pt-3">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: jobResponsibilities,
                              }}
                            ></div>
                          </div>
                        </div>
                        <div className="jobBox hidden rounded-2xl">
                          <div className="text-base pt-3">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: jobRequirements,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <FeaturedEmp />
          </main>
        </div>
        <Footer />
      </div>
    </>
  );
};
export default JobTemplate001;